import React, {Component} from 'react';
import {Breadcrumbs} from '@mui/material';
import {YMaps, Map, Placemark} from '@iminside/react-yandex-maps';
import isEmpty from 'is-empty';
import useWithStore from "@/Hooks/useWithStore";
import reachGoalYM from "@/Helpers/ReachGoalYM";
import {clearPhone} from "@/Helpers/Function";
import BaseLayout from "@/Layouts/BaseLayout";
import reachGoalGA from "@/Helpers/ReachGoalGA";
import Link from "@/Layouts/Link";
import "@/Scss/Site/Contacts/index.scss";

class Index extends Component {
    constructor(props) {
        super(props);

        this.state = {
            zoom: 9,
            setCenterMainOfficeX: 57.648399,
            setCenterMainOfficeY: 40.928913,
            map: null
        };

        mainOffice.forEach((el) => {
            try {
                this.state[`placeMark_${el.id}`] = null;
            } catch (e) {
                console.log('e', e);
            }
        });
    }

    /**
     * Передвигаем карту к метке и открываем balloon
     * @param targetX
     * @param targetY
     */
    getInfoOffice(event, targetX, targetY, id) {
        try {
            const elements = document.querySelectorAll('.jsBoardItem');
            elements.forEach((el) => el.classList.remove('active'));
            event.currentTarget.closest('.jsBoardItem').classList.add("active");

            this.setState({
                setCenterMainOfficeX: Number(targetX),
                setCenterMainOfficeY: Number(targetY),
                zoom: 15
            });
            setTimeout(() => {
                this.state[`placeMark_${id}`].balloon.open(); // открытие балуна
            }, 0)
        } catch (e) {
            console.log('e', e);
        }
    }

    componentDidMount = () => {
        reachGoalYM('contacts');
        reachGoalGA('contacts');
    };

    phone = (phone = '') => {
        let newPhone = phone !== '' ? phone.split('|') : [];
        let result = '';
        if (newPhone.length >= 1) {
            result = newPhone.map((el, i, arr) => {
                if (arr.length - 1 === i) {
                    // last phone
                    return <a key={i}
                              href={`tel:+7${clearPhone(el)}`}>
                        {el}
                    </a>
                } else {
                    // not last phone
                    return <a key={i}
                              href={`tel:+7${clearPhone(el)}`}>
                        {el + ', '}
                    </a>
                }
            })
        }
        return result;
    };

    mail = (mail = '') => {
        let newMail = mail !== '' ? mail.split('|') : [];
        let result = '';
        if (newMail.length >= 1) {
            result = newMail.map((el, i, arr) => {
                if (arr.length - 1 === i) {
                    // last mail
                    return <a key={i}
                              href={`mailto:${el}`}>
                        {el}
                    </a>
                } else {
                    // not last mail
                    return <a key={i}
                              href={`mailto:${el}`}>
                        {el + ', '}
                    </a>
                }
            })
        }
        return result;
    };

    render() {
        const {mobileApp = false} = this.props;
        const {
            setCenterMainOfficeX,
            setCenterMainOfficeY,
            zoom
        } = this.state;

        const element = mainOffice.map((el) => {
            try {
                return <div key={el.id} className={`board-item jsBoardItem`}>
                    <p className={`board-item__title`}>{el.title}</p>
                    {!isEmpty(el.address) && (<p className={`board-item__item`}>{el.address}</p>)}
                    {!isEmpty(el.email) && (<p className={`board-item__item`}>{this.mail(el.email)}</p>)}
                    {!isEmpty(el.phone) && (<p className={`board-item__item`}>{this.phone(el.phone)} {el.info}</p>)}
                    {!isEmpty(el.phone_mobile) && (
                        <p className={`board-item__item`}>{this.phone(el.phone_mobile)} (MAX, Telegram)</p>)}
                    {!isEmpty(el.operating_mode) && (
                        <p className={`board-item__item`}>Время работы: {el.operating_mode}</p>)}
                    {el.target_x !== 0 && el.target_y !== 0 && (
                        <div className={`board-item__link jsBoardLink`}
                             onClick={(event) => this.getInfoOffice(event, el.target_x, el.target_y, el.id)}
                        >
                            <p>Показать на карте</p>
                        </div>
                    )}
                </div>
            } catch (e) {
                console.log('e', e);
            }
        });

        let myIcon = '/storage/img/maps/platina-open.png';
        const MyPlaceMark = mainOffice.map((el) => {
            // Создаем собственный макет с информацией о выбранном геообъекте.
            let title = '', address = '', email = '', phone = '', time = '';
            if (!isEmpty(el.title)) {
                title = '<p class="balloon__title">' + el.title + '</p>'
            }
            if (!isEmpty(el.address)) {
                address = '<p class="balloon__body">' + el.address + '</p>'
            }
            if (!isEmpty(el.email)) {
                email = '<p class="balloon__body">Email: ' + el.email.replaceAll('|', ', ') + '</p>'
            }
            if (!isEmpty(el.phone)) {
                phone = '<p class="balloon__body">Телефон: ' + el.phone.replaceAll('|', ', ') + '</p>'
            }
            if (!isEmpty(el.operating_mode)) {
                time = '<p class="balloon__body">Время работы: ' + el.operating_mode + '</p>'
            }
            const customItemContentLayout = '<div class="balloon">' +
                title + address + email + phone + time +
                '</div>';

            return <Placemark key={el.id}
                              instanceRef={ref => (this.state[`placeMark_${el.id}`] = ref)}
                              geometry={[el.target_x, el.target_y]}
                              options={{
                                  iconLayout: 'default#image',
                                  iconImageHref: myIcon,
                                  balloonPanelMaxMapArea: Infinity,
                              }}
                              properties={{
                                  hintContent: customItemContentLayout,
                                  balloonContent: customItemContentLayout
                              }}
                              modules={['geoObject.addon.balloon', 'geoObject.addon.hint']}
            />
        });

        return <BaseLayout {...this.props}>
            <section className={`section`}>
                {!mobileApp && (
                    <div className={`breadcrumbs`}>
                        <div className="container">
                            <Breadcrumbs
                                maxItems={2}
                                itemsAfterCollapse={2}
                            >
                                <Link className="breadcrumbs__link" href={`/`}>
                                    Главная
                                </Link>
                                <p className="breadcrumbs__text">
                                    Контакты
                                </p>
                            </Breadcrumbs>
                        </div>
                    </div>
                )}
                <div className={`container`}>
                    <h1 className={`h1`}>Контакты</h1>
                    <div className={`maps`}>
                        <div className={`maps__board`}>
                            <div className={`maps__navParent`}>
                                <Link href={`/contacts${mobileApp ? '?mobileApp=1' : ''}`}
                                      className={`nav-item active`}>
                                    Наши адреса
                                </Link>
                                <Link href={`/shops${mobileApp ? '?mobileApp=1' : ''}`}
                                      className={`nav-item`}>Магазины</Link>
                            </div>
                            <div className={`maps__info`}>
                                {element}
                            </div>
                        </div>
                        <div className={`maps__wrapper`}>
                            <YMaps query={{
                                lang: 'ru_RU',
                                apikey: '1be71b9b-1bc9-47c4-bb72-a6acd502cc6d'
                            }}
                            >
                                <Map state={{
                                    center: [setCenterMainOfficeX, setCenterMainOfficeY],
                                    zoom: zoom
                                }}
                                     instanceRef={ref => (this.map = ref)}
                                     width={`100%`}
                                     height={`100%`}
                                >
                                    {MyPlaceMark}
                                </Map>
                            </YMaps>
                        </div>
                    </div>
                </div>
            </section>
        </BaseLayout>
    }
}


const mainOffice = [
    {
        "target_x": 0,
        "target_y": 0,
        "title": "Интернет-магазин PLATINA",
        "address": "",
        "info": "(Звонок из любого региона России бесплатный)",
        "phone": "+7-800-350-15-95",
        "phone_mobile": "+7 910 952-20-22",
        "email": "help@platina-jewelry.ru",
        "operating_mode": "с 9:00 до 17:30 (пн.-пт.)",
        // "operating_mode": "с 9:00 до 17:30 (пн.-пт.), в праздничные дни с 31.12.2022 до 03.01.2023 (включительно): с 10:00 до 17:30",
    },
    // {
    //     "target_x": 57.770078,
    //     "target_y": 40.913626,
    //     "title": "Ювелирный завод \"ПЛАТИНА\"",
    //     "address": "156000, Костромская обл., г.Кострома, ул.Комсомольская, дом 4А, офис 38/3",
    //     "info": "",
    //     "phone": "+7 (49432) 3-10-08|+7 (49432) 3-10-12",
    //     "phone_mobile": "",
    //     "email": "office@platina-jewelry.ru",
    //     "operating_mode": "с 9:00 до 17:30 (пн.-пт.)",
    // },
    {
        "target_x": 57.523801,
        "target_y": 41.239014,
        "title": "Ювелирный завод \"ПЛАТИНА\"",
        "address": "157940, Костромская обл., пгт. Красное-на-Волге, ул. Окружная, дом 8",
        "info": "",
        "phone": "+7 (499) 300-14-07|+7 (49432) 3-10-10|+7 (49432) 3-10-08",
        "phone_mobile": "",
        "email": "office@platina-jewelry.ru",
        "operating_mode": "с 9:00 до 17:30 (пн.-пт.)",
    }
].map((n, i) => ({...n, id: i + 1}));

export default useWithStore(Index);
